import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import { Segment, Divider, Input, Button } from 'semantic-ui-react';

export function coursePicker(){
    const options = [
        { key: 1, text: 'Anti Skid', value: 'Anti Skid'},
        { key: 2, text: 'Off Road', value: 'Off Road' },
        { key: 3, text: 'Guvenli Surus- Agir Vasita', value: 'DSTAv'},
        { key: 4, text: 'Guvenli Surus- Otomobil', value: 'DSTOto' },
    ]; 
    return (
        <Dropdown 
            id='Egitimler-top'
            style={{width: '50%'}} 
            placeholder='Anti Skid' 
            options={options} 
            fluid 
            selection 
            onChange = {this.changeCPicker.bind(this)} />
    );
}



// WEBPACK FOOTER //
// ./src/components/PanelPages/coursePicker.jsx